module.exports = __webpack_public_path__ + "static/media/natours.bb36e71e.png";